<template>
  <div class="check-in">
    <SliderDisplay class="check-in__caroussel" />
    <div class="check-in__content">
      <form class="check-in__form" @submit.prevent="handleForm">
        <VInput class="check-in__input" label="Insira o CPF da pessoa a ser atendida" v-model="cpf"
          v-mask="'###.###.###-##'" :errorMessage="errorMessageCPF" inputmode="numeric"
          maxlength="14" @keypress="inputAllowNumbersOnly" @focus="keyboardUpReposition" />
        <div class="check-in__btn">
          <VButton text="Continuar" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import checkinMixins from '@/utils/mixins/checkin.mixins';
import SliderDisplay from './SliderDisplay.vue';
import validateCpf from '@/utils/helpers/validation/validateCpf';

import { CPF_NOT_VALID, CPF_WRONG_SIZE, LOCAL_STORAGE_CPF } from '@/utils/constants/checkin.constants';

export default {
  name: 'CheckinMainFlow',
  components: {
    SliderDisplay
  },
  mixins: [checkinMixins],
  data: () => ({
    cpf: '',
    errorMessageCPF: ''
  }),
  created() {
    this.inputCPFAutofiller();
  },
  watch: {
    cpf() {
      this.errorMessageCPF = '';
    },
  },
  methods: {
    /**
     * @method handleForm
     * @description Set CPF in localStorage and start check-in if the data is valid
     */
    handleForm() {
      const cpfIsValid = this.CPFValidation();
      if (!cpfIsValid) {
        return;
      }
      const userCpf = this.unmaskedCpf(this.cpf);
      sessionStorage.setItem(LOCAL_STORAGE_CPF, userCpf);
      if (cpfIsValid) {
        this.$emit('submit-form', userCpf);
      }
    },
    /**
   * @method CPFValidation
   * @description Checks if inputted value if an valid CPF and adds masker
   */
    CPFValidation() {
      const isCpfLengthValid = this.cpf.length === 14;

      const isCpfNumberValid = validateCpf(this.unmaskedCpf(this.cpf));
      if (!this.cpf || !isCpfLengthValid) {
        this.errorMessageCPF = CPF_WRONG_SIZE;
        return false;
      }

      if (isCpfLengthValid && !isCpfNumberValid) {
        this.errorMessageCPF = CPF_NOT_VALID;
        return false;
      }
      return true;
    },
    /**
     * @method keyboardUpReposition
     * @description Scrolls to button element when digital keyboard is displayed
     */
    keyboardUpReposition() {
      const buttonElement = this.$el.getElementsByClassName('check-in__btn')[0];
      const oldScreenHeight = window.innerHeight;
      let newScreenHeight;

      setTimeout(() => {
        newScreenHeight = window.innerHeight;
        if (oldScreenHeight > newScreenHeight && buttonElement) {
          buttonElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 200);
    },
  }
};
</script>

<style lang="scss" scoped>
.check-in {
  &__carousel {
    border: none;
    margin-top: 40px;
  }

  &__input {
    margin: 15% 0 5% 0;
  }

  &__content {
    &--combo {
      &>button {
        margin-top: 16px;
      }
    }
  }
}
</style>
